import React, { forwardRef } from "react";
import phone from "../assets/icons/phone.svg";
import location from "../assets/icons/location.svg";
import mail from "../assets/icons/mail.svg";

const Hubungi = forwardRef((props, ref) => {
  return (
    <div className="w-full bg-white-hvs" ref={ref}>
      <div className="container px-4 py-16 mx-auto">
        <h1 className="mb-6 text-4xl font-bold text-center text-matiLampu">Hubungi Kami</h1>
        <div className="grid grid-cols-1 divide-y md:grid-cols-3 md:divide-x md:divide-y-0 divide-solid divide-matiLampu divide-opacity-20 text-matiLampu">
          <div className="flex flex-col items-center px-2 py-4 md:px-1">
            <img src={phone} alt="phone" />
            <div className="mb-2 text-xl">Telepon</div>
            <div>+6221 - 38869001</div>
            <div>+6221 - 38869002</div>
          </div>
          <div className="flex flex-col items-center px-2 py-4 md:px-1">
            <img src={mail} alt="mail" />
            <div className="mb-2 text-xl">E-Mail</div>
            <div>support@phs.co.id</div>
          </div>
          <div className="flex flex-col items-center px-2 py-4 md:px-1">
            <img src={location} alt="location" />
            <div className="mb-2 text-xl">Alamat</div>
            <div className="text-center">
              Jl. H. Naman No. 8A Pondok Kelapa, Duren Sawit              
              <br />
              Jakarta Timur
              <br />
              13450
            </div>
          </div>
        </div>
      </div>
    </div>
  )
});

export default Hubungi;
